import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./styles.module.scss";

const ChecklistFormContainer = React.memo(({ className, ...props }) => (
  <div
    {...props}
    className={classNames([
      styles.formFieldContainer,
      styles.checklistFormContainer,
      className,
    ])}
    data-testid="checklist-form-container"
  />
));

ChecklistFormContainer.propTypes = {
  className: PropTypes.string
};

export default ChecklistFormContainer;
